var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj},[_c('Sidebar',{staticClass:"sidebar-container"}),_c('v-main',{staticClass:"main-container"},[_c('Navbar'),_c('TagsView'),_c('AppMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }